<template>
  <div style="min-height: 350px">
    <div class="d-flex justify-content-between mb-3">
      <div class="">
        <h5 class="text-primary"
          ><strong>PECENTAGE FLEET AVAILABILITY</strong></h5
        >
      </div>
    </div>
    <div class="my-5 d-flex justify-content-center" v-if="loading">
      <b-spinner style="height: 74px; width: 74px"></b-spinner>
    </div>
    <template v-else>
      <!-- <PercentageAvailabilityChart
        :series="series"
        :element="`percentage-fleet-availability`"
      /> -->
      <PercentageAvailabilityChartYearly
        :series="seriesYearly"
        :element="`percentage-fleet-availability-yearly`"
      />
    </template>
  </div>
</template>
<script>
import { srActions } from '@/src/Utils/helper'
import PercentageAvailabilityChart from './Chart/PercentageAvailabilityChart.vue'
import PercentageAvailabilityChartYearly from './Chart/PercentageAvailabilityChartYearly.vue'
import moment from '@/node_modules/moment/moment'

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    PercentageAvailabilityChart,
    PercentageAvailabilityChartYearly
  },
  data() {
    return {
      chartIdx: 0,
      series: [
        {
          name: 'Actual Availability',
          type: 'column',
          color: '#23af33',
          data: [],
          alias: 'actual_availability',
        },
        {
          name: 'Actual Breakdown',
          type: 'column',
          color: '#d9534f',
          data: [],
          alias: 'actual_breakdown',
        },
        {
          name: 'Actual Docking',
          type: 'column',
          color: '#f0ad4e',
          data: [],
          alias: 'actual_docking',
        },
        {
          name: 'Target Availability',
          type: 'line',
          color: '#454545',
          data: [],
          alias: 'line',
        },
      ],
      seriesYearly: [
        {
          name: 'Actual Availability',
          type: 'column',
          color: '#23af33',
          data: [],
          alias: 'actual_availability',
        },
        {
          name: 'Actual Breakdown',
          type: 'column',
          color: '#d9534f',
          data: [],
          alias: 'actual_breakdown',
        },
        {
          name: 'Actual Docking',
          type: 'column',
          color: '#f0ad4e',
          data: [],
          alias: 'actual_docking',
        },
        {
          name: 'Plan Availability',
          type: 'line',
          color: '#177221',
          data: [],
          alias: 'line_availability',
        },
        {
          name: 'Plan Docking',
          type: 'line',
          color: '#986E32',
          data: [],
          alias: 'line_docking',
        },
        {
          name: 'Plan Breakdown',
          type: 'line',
          color: '#953936',
          data: [],
          alias: 'line_breakdown',
        },
      ],
      loading: false,
      user_id: JSON.parse(localStorage.getItem('profile')).id,
      year: moment(),
    }
  },
  methods: {
    ...srActions,
    async fetchFleetReports() {
      try {
        this.loading = true
        const body = {
          year: moment(this.params?.year).format('YYYY'),
          vehicle_type_ids: this.params.vehicle_type_ids?.map(
            (item) => item.id
          ),
          vehicle_ids: this.params.vehicle_ids?.map((item) => item.id)
        }
        const params = {
          user_id: this.user_id,
        }
        const res = await this.fetchReportFleetAvailabilityDashboard({
          params,
          body,
        })
        // this.fleetReports = res.data
        for (let key in res.data) {
          this.series.forEach((item) => {
            if (item.alias === key) {
              item.data = res.data[key].map((item) => item.total)
            }
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async fetchFleetReportsYearly() {
      try {
        this.loading = true
        const body = {
          year: moment(this.params?.year).format('YYYY'),
          vehicle_type_ids: this.params.vehicle_type_ids?.map(
            (item) => item.id
          ),
          vehicle_ids: this.params.vehicle_ids?.map((item) => item.id)
        }
        const params = {
          user_id: this.user_id,
        }
        const res = await this.fetchReportFleetAvailabilityDashboardYearly({
          params,
          body,
        })
        // this.fleetReports = res.data
        for (let key in res.data) {
          this.seriesYearly.forEach((item) => {
            if (item.alias === key) {
              item.data = res.data[key].map((item) => item.total)
            }
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    next() {
      this.chartIdx = this.chartIdx + 1
    },
    prev() {
      this.chartIdx = this.chartIdx - 1
    },
  },
  watch: {
    params: {
      handler() {
        this.fetchFleetReports()
        this.fetchFleetReportsYearly()
      },
      deep: true,
    },
  },
  mounted() {
    this.fetchFleetReports()
    this.fetchFleetReportsYearly()
  },
}
</script>
<style>
.bg-head-availablility {
  background: #27bb2d;
}
</style>
